var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 70,
    viewBox: "0 0 32 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.569 35.2404C12.2699 46.7098 19.7623 55.7915 29.3195 55.8419L28.9752 69.0442C13.1609 69.1388 0.857795 54.191 1.34496 35.5083C1.83212 16.8256 14.9303 1.28274 30.759 0.636161L30.415 13.8284C20.8435 14.3269 12.868 23.7709 12.569 35.2404Z",
    stroke: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLeft);
export default __webpack_public_path__ + "static/media/footer-left.b83e0f40bc454d1649ae2f682790558e.svg";
export { ForwardRef as ReactComponent };